

(function($) { "use strict";


	//Check we are on a page containing hero slider
	if( $('.section-hero-slider').length ) {

		//When button is clicked
		$(".js-search-developments").on('click', function(event) {

			// Redirect to developments page (leaving the query string intact)
			window.location.pathname = '/developments/';
			
		});

	}

	// Target and hide Property status if the status if 'Available'
	$('.property-attributes .icon-status:contains("Available")').hide(); // Single property template
	$('.wpgb-card-footer .status:contains("Available")').hide(); // Properties list view




})(jQuery);


